"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_SORT_DIRECTIONS = void 0;
var TABLE_SORT_DIRECTIONS = Object.freeze({
  ascending: 'ascending',
  descending: 'descending',
  none: 'none'
});
exports.TABLE_SORT_DIRECTIONS = TABLE_SORT_DIRECTIONS;